module.exports = __webpack_public_path__ + "img/audition.c73dea40.png";